import { LitElement, html, css } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import AppAnalytics from '../analytics/AppAnalytics';

@customElement('ai-vet-chat')
export class AiVetChat extends LitElement {
  static styles = css`
    :host {
      position: fixed;
      bottom: 24px;
      right: 24px;
      z-index: 1000;
      font-family: inherit;
    }

    .chat-button {
      width: 64px;
      height: 64px;
      border-radius: 50%;
      border: none;
      cursor: pointer;
      box-shadow:
        0 8px 24px rgba(139, 92, 246, 0.3),
        0 4px 12px rgba(139, 92, 246, 0.2);
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      font-size: 28px;
      animation: gentleBounce 3s ease-in-out infinite;
      overflow: hidden;
      position: fixed;
      bottom: 6rem;
      right: 1rem;
    }

    .chat-button::before {
      content: '';
      position: absolute;
      top: -2px;
      left: -2px;
      right: -2px;
      bottom: -2px;
      background: linear-gradient(135deg, #a855f7, #8b5cf6, #7c3aed);
      border-radius: 50%;
      z-index: -1;
      opacity: 0;
      transition: opacity 0.3s ease;
    }

    .chat-button:hover {
      transform: scale(1.1) translateY(-2px);
      box-shadow:
        0 12px 32px rgba(139, 92, 246, 0.4),
        0 8px 16px rgba(139, 92, 246, 0.3);
      animation-play-state: paused;
    }

    .chat-button:hover::before {
      opacity: 1;
    }

    .chat-button.open {
      background: linear-gradient(135deg, #f43f5e 0%, #e11d48 100%);
      box-shadow:
        0 8px 24px rgba(244, 63, 94, 0.3),
        0 4px 12px rgba(244, 63, 94, 0.2);
      animation: none;
      transform: scale(0.95);
      bottom: 3rem;
    }

    @keyframes gentleBounce {
      0%, 20%, 50%, 80%, 100% {
        transform: translateY(0);
      }
      40% {
        transform: translateY(-4px);
      }
      60% {
        transform: translateY(-2px);
      }
    }

    .chat-window {
      position: fixed;
      bottom: 12rem;
      right: 1rem;
      width: 360px;
      height: 520px;
      background: white;
      border-radius: 20px;
      box-shadow:
        0 25px 50px -12px rgba(0, 0, 0, 0.15),
        0 20px 25px -5px rgba(0, 0, 0, 0.1);
      transform-origin: calc(100% - 32px) 100%;
      transition: all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
      border: 1px solid rgba(139, 92, 246, 0.1);
      overflow: hidden;
      backdrop-filter: blur(10px);
    }

    .chat-window.hidden {
      transform: scale(0) rotate(5deg);
      opacity: 0;
      pointer-events: none;
    }

    .chat-window.visible {
      transform: scale(1) rotate(0deg);
      opacity: 1;
      animation: windowSlideUp 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
    }

    @keyframes windowSlideUp {
      0% {
        transform: scale(0.3) translateY(50px) rotate(-5deg);
        opacity: 0;
      }
      50% {
        transform: scale(1.05) translateY(-10px) rotate(2deg);
        opacity: 0.8;
      }
      100% {
        transform: scale(1) translateY(0) rotate(0deg);
        opacity: 1;
      }
    }

    .chat-header {
      padding: 20px;
      border-bottom: 1px solid rgba(139, 92, 246, 0.1);
      background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
      color: white;
      position: relative;
      overflow: hidden;
    }

    .chat-header::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(45deg, rgba(255,255,255,0.1) 0%, transparent 100%);
      pointer-events: none;
    }

    .chat-body {
      height: 350px;
      padding: 16px;
      overflow-y: auto;
    }

    .chat-input-area {
      padding: 16px;
      border-top: 1px solid #e5e7eb;
      background: #f9fafb;
    }

    .message {
      margin-bottom: 12px;
      padding: 8px 12px;
      border-radius: 8px;
      max-width: 80%;
    }

    .message.user {
      background: #3b82f6;
      color: white;
      margin-left: auto;
    }

    .message.assistant {
      background: #f3f4f6;
      color: #374151;
    }

    .input-container {
      display: flex;
      gap: 8px;
    }

    .chat-input {
      flex: 1;
      padding: 8px 12px;
      border: 1px solid #d1d5db;
      border-radius: 6px;
      outline: none;
      width: 90%;
    }

    .chat-input:focus {
      border-color: #3b82f6;
      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }

    .send-button {
      padding: 8px 16px;
      background: #3b82f6;
      color: white;
      border: none;
      border-radius: 6px;
      cursor: pointer;
    }

    .send-button:hover {
      background: #2563eb;
    }

    .send-button:disabled {
      background: #9ca3af;
      cursor: not-allowed;
    }

    .email-capture {
      padding: 16px;
      background: #f0f9ff;
      border: 1px solid #e0f2fe;
      border-radius: 8px;
      margin-bottom: 16px;
    }

    .email-input {
      width: 100%;
      padding: 8px 12px;
      border: 1px solid #d1d5db;
      border-radius: 6px;
      margin-bottom: 8px;
      outline: none;
    }

    .email-submit {
      width: 100%;
      padding: 8px 16px;
      background: #059669;
      color: white;
      border: none;
      border-radius: 6px;
      cursor: pointer;
    }

    .email-submit:hover {
      background: #047857;
    }

    .intro-message {
      text-align: center;
      color: #6b7280;
      padding: 20px;
    }

    @media (max-width: 640px) {
      :host {
        bottom: 20px;
        right: 20px;
      }

      .chat-button {
        width: 56px;
        height: 56px;
        font-size: 24px;
      }

      .chat-body {
        height: 300px;
        padding: 16px;
        overflow-y: auto;
      }

      .chat-window {
        width: 320px;
        height: 480px;
        bottom: 7rem;
        right: 1rem;
      }
    }

    .chat-prompt-bubble {
      position: fixed;
      bottom: 11rem;
      right: 1.5rem;
      background: white;
      color: #374151;
      padding: 12px 16px;
      border-radius: 16px;
      box-shadow:
        0 8px 16px rgba(0, 0, 0, 0.1),
        0 4px 8px rgba(0, 0, 0, 0.06);
      font-size: 14px;
      font-weight: 500;
      white-space: nowrap;
      transform-origin: bottom right;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      border: 1px solid rgba(139, 92, 246, 0.2);
      max-width: 200px;
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      animation: gentleBounce 3s ease-in-out infinite;
    }

    .chat-prompt-bubble::after {
      content: '';
      position: absolute;
      bottom: -6px;
      right: 20px;
      width: 12px;
      height: 12px;
      background: white;
      border-right: 1px solid rgba(139, 92, 246, 0.2);
      border-bottom: 1px solid rgba(139, 92, 246, 0.2);
      transform: rotate(45deg);
    }

    .chat-prompt-bubble.hidden {
      opacity: 0;
      transform: scale(0.8) translateY(10px);
      pointer-events: none;
    }

    .chat-prompt-bubble.visible {
      opacity: 1;
      transform: scale(1) translateY(0);
    }

    @keyframes bubbleFloat {
      0% {
        transform: translateY(0px);
      }
      100% {
        transform: translateY(-3px);
      }
    }

    @media (max-width: 640px) {
      .chat-prompt-bubble {
        max-width: 180px;
        font-size: 13px;
      }

      .chat-prompt-bubble::after {
        right: 16px;
      }
    }
  `;

  @state() private isOpen = false;
  @state() private messages: Array<{text: string, sender: 'user' | 'assistant'}> = [];
  @state() private currentMessage = '';
  @state() private showEmailCapture = false;
  @state() private email = '';
  @state() private emailSubmitted = false;
  @state() private showPromptBubble = true;

  private toggleChat() {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      this.showPromptBubble = false;
      AppAnalytics.getPlausible().trackEvent('AI Vet Chat Opened');
    }
    this.requestUpdate()
  }

  private handleMessageSubmit(e: Event) {
    e.preventDefault();
    if (!this.currentMessage.trim()) return;

    const userMessage = this.currentMessage.trim();
    this.messages = [...this.messages, { text: userMessage, sender: 'user' }];

    // Track the user's question
    AppAnalytics.getPlausible().trackEvent('AI Vet Question Asked', {
      props: {
        question: userMessage.substring(0, 100), // Limit length for analytics
        questionLength: userMessage.length
      }
    });

    this.currentMessage = '';
    this.showEmailCapture = true;

    // Add a response explaining the feature isn't ready yet
    setTimeout(() => {
      this.messages = [/*...this.messages,*/ {
        text: "Thanks for your question! Our AI vet assistant is coming soon. Please leave your email below and we'll notify you when it launches.",
        sender: 'assistant'
      }];
      this.requestUpdate()
    }, 500);
      this.requestUpdate()
  }

  private handleEmailSubmit(e: Event) {
    e.preventDefault();
    if (!this.email.trim()) return;

    const FREEDOM_CRM_API = 'https://crm.caninehealthcenter.com';
    const FREEDOM_CRM_SITE_ID = 'caninehealthcenter.com';

    // Track email capture
    AppAnalytics.getPlausible().trackEvent('AI Vet Email Captured', {
      props: {
        email: this.email
      }
    });

    // Update UI to show submitting state
    const submitButton = this.querySelector('.email-submit') as HTMLButtonElement;
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Submitting...';
    }

    fetch(`${FREEDOM_CRM_API}/new-contact`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: this.email, siteId: FREEDOM_CRM_SITE_ID })
    })
      .then(res => {
        if (!res.ok) throw new Error('Signup failed');
        // Success
        this.email = '';
        this.emailSubmitted = true;
        this.messages = [...this.messages, {
          text: "Perfect! We've saved your email and will notify you as soon as our AI vet assistant is ready. Thanks for your interest!",
          sender: 'assistant'
        }];
      })
      .catch(() => {
        this.messages = [...this.messages, {
          text: "Something went wrong with your email signup. Please try again!",
          sender: 'assistant'
        }];
      })
      .finally(() => {
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = 'Notify Me';
        }
        this.requestUpdate();
      });
  }

  private handleInputKeyPress(e: KeyboardEvent) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      this.handleMessageSubmit(e);
    }
    this.requestUpdate();
  }

  createRenderRoot() {
    return this;
  }

  render() {
    return html`
      <style>${AiVetChat.styles.cssText}</style>

      <div class="chat-prompt-bubble ${this.showPromptBubble && !this.isOpen ? 'visible' : 'hidden'}" @click=${this.toggleChat}>
        Got a question? 🐕
      </div>

      <button class="chat-button ${this.isOpen ? 'open' : ''}" @click=${this.toggleChat}>
        ${this.isOpen ? '✕' : '🐾'}
      </button>

      <div class="chat-window ${this.isOpen ? 'visible' : 'hidden'}">
        <div class="chat-header">
          <h3 style="margin: 0; font-size: 18px; font-weight: 600;">🐕 AI Vet Assistant</h3>
          <p style="margin: 4px 0 0 0; font-size: 14px; opacity: 0.9;">Ask me anything about your dog's health</p>
        </div>

        <div class="chat-body">
          ${this.messages.length === 0 ? html`
            <div class="intro-message">
              <div style="font-size: 48px; margin-bottom: 12px;">🐾</div>
              <h4 style="margin: 0 0 8px 0; color: #374151;">Hi there!</h4>
              <p style="margin: 0; font-size: 14px;">I'm here to help answer questions about your dog's health and wellness. What would you like to know?</p>
            </div>
          ` : ''}

          ${this.messages.map(message => html`
            <div class="message ${message.sender}">
              ${message.text}
            </div>
          `)}

          ${this.showEmailCapture && !this.emailSubmitted ? html`
            <div class="email-capture">
              <h4 style="margin: 0 0 8px 0; font-size: 14px; font-weight: 600; color: #0f172a;">Get notified when we launch!</h4>
              <form @submit=${this.handleEmailSubmit}>
                <input
                  type="email"
                  class="email-input"
                  placeholder="Enter your email address"
                  .value=${this.email}
                  @input=${(e: Event) => {
                    this.email = (e.target as HTMLInputElement).value;
                  }}
                  required
                />
                <button type="submit" class="email-submit">Notify Me</button>
              </form>
            </div>
          ` : ''}
        </div>

        <div class="chat-input-area">
          <form class="input-container" @submit=${this.handleMessageSubmit}>
            <input
              type="text"
              class="chat-input"
              placeholder="Type your question..."
              .value=${this.currentMessage}
              @input=${(e: Event) => this.currentMessage = (e.target as HTMLInputElement).value}
              @keypress=${this.handleInputKeyPress}
            />
            <button type="submit" class="send-button" ?disabled=${!this.currentMessage.trim()}>
              Send
            </button>
          </form>
        </div>
      </div>
    `;
  }
}
